import { CheckerboardMainInfoTab, CheckerboardState } from "@app/types/facilityTypes";

export const initialState: CheckerboardState = {
    checkerboardIsFetching: false,
    checkerboardIsLoading: false,
    createCheckerboardInProcess: false,
    mainInfoActiveTab: CheckerboardMainInfoTab.BASIC,
    removeCheckerboardInProcess: false,
    updateCheckerboardInProcess: false,
}